<template>
	<div>
		<b-col md="12">
			<h1 :class="[`${!$screen.sm ? 'main-page-title' : ''}`, { 'is-pwa': $isPwa() }]">
				{{ FormMSG(10000, 'Profile') }}
			</h1>
		</b-col>
		<loading :active.sync="isLoadingVaultCheck" :is-full-page="true" />
		<div :class="`${$screen.width <= 576 ? 'my-project' : ''}`">
			<b-tabs
				v-model="tabs.activeTabs"
				active-nav-item-class="font-weight-bold"
				active-tab-class="font-weight-bold"
				@activate-tab="(n, p, e) => onTabClicked(n)"
			>
				<b-tab :title="FormMSG(200, 'Profile')">
					<profile-tab @profile-updated="onProfileUpdated" />
				</b-tab>
				<b-tab v-if="canAccessDealMemo" lazy :title="FormMSG(300, 'Contracts')">
					<Mycontracts />
				</b-tab>
				<b-tab v-if="!isFilmSingle && !isFilmSingleFree && useDoc" lazy :title="FormMSG(301, 'Documents')">
					<MyDocuments />
				</b-tab>
				<b-tab v-if="showDocsVault" lazy :title="FormMSG(302, 'Docs Vault')">
					<documents-vault />
				</b-tab>
			</b-tabs>
		</div>
	</div>
</template>
<script>
import languageMessages from '@/mixins/languageMessages';
import isSingleProjectMixin from '@/mixins/isSingleProject.mixin';
import GlobalMixin from '@/mixins/global.mixin';
import Mycontracts from './mycontracts.vue';
import profileTab from './profileScreenToTab';
import MyDocuments from '../views/documents/mydocuments.vue';
import DocumentsVault from './documents/DocumentsVault.vue';
import { store } from '@/store';
import activeTabMixin from '@/mixins/activeTab.mixin';
import { getAmazoneS3TreeAsJsonString } from '@/modules/document-package/cruds/document.crud';
import Loading from 'vue-loading-overlay';

export default {
	name: 'Profile',
	components: { Mycontracts, profileTab, MyDocuments, DocumentsVault, Loading },
	mixins: [languageMessages, isSingleProjectMixin, GlobalMixin, activeTabMixin],

	data() {
		return {
			isLoadingVaultCheck: true,
			tabs: {
				showDocsVault: false
			}
		};
	},
	computed: {
		myProjectConfig() {
			return store.getCurrentProjectConfig();
		},
		useDoc() {
			return this.myProjectConfig ? this.myProjectConfig.useDocument : false;
		},
		canAccessDealMemo() {
			return this.myProjectConfig ? !this.myProjectConfig.hideDealMemoInfo : false;
		},
		showDocsVault() {
			return this.tabs.showDocsVault;
		}
	},
	watch: {
		'$route.query.activeTabContract': {
			handler(newVal) {
				if (newVal) {
					this.tabs.activeTabs = 1;
				}
			},
			immediate: true,
			deep: true
		},
		'$route.query.forDocs': {
			handler(newVal) {
				if (newVal) {
					this.tabs.activeTabs = 2;
				}
			},
			immediate: true,
			deep: true
		},
		'$route.query': {
			handler() {
				setTimeout(() => {
					if (this.$route.query.tabs) {
						this.handleTabsQuery();
					} else {
						this.tabs.activeTabs = 0;
					}
				}, 300);
			},
			immediate: true,
			deep: true
		}
	},
	async created() {
		await this.checkVaultDocuments();
		this.initTabs();
	},
	methods: {
		async checkVaultDocuments() {
			try {
				const result = await getAmazoneS3TreeAsJsonString();
				if (result && result.Children && result.Children.length > 0) {
					const hasDocuments = result.Children[0].Children && result.Children[0].Children.length > 0;
					this.tabs.showDocsVault = hasDocuments;
				} else {
					this.tabs.showDocsVault = false;
				}
			} catch (err) {
				console.error('Failed to check vault documents', err);
				this.tabs.showDocsVault = false;
			} finally {
				this.isLoadingVaultCheck = false;
			}
		},
		async onProfileUpdated() {
			await this.checkVaultDocuments();
		}
	}
};
</script>
<style></style>
